import { render, staticRenderFns } from "./NewServiceDocumentPage.vue?vue&type=template&id=6e35aeec&scoped=true"
import script from "./NewServiceDocumentPage.vue?vue&type=script&lang=js"
export * from "./NewServiceDocumentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e35aeec",
  null
  
)

export default component.exports